module.exports = __webpack_public_path__ + "static/img/ops.d5bf2b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ops.png
// module id = 5s1+
// module chunks = 0